import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React from "react"
import { StaticQuery, graphql } from "gatsby"
import "./categories.css"


class CategoriesOutput extends React.Component {
   render() {
      const { data } = this.props;
      const categories = data.wpPost.postFields.categories;
      return (
         <div className="categories">
            <h4>Categories <span></span></h4>
            <ul>
               {categories.map((category,index) => (
                  <li key={index} className={category.slug}><Link to={`/${category.slug}`}><span>{category.name}</span></Link></li>
               ))}
            </ul>
         </div>
      )
  }
}

export default function Categories(props) {
   return (
     <StaticQuery
       query={graphql`
         query {
            wpPost(databaseId: {eq: 2977}) {
               postFields {
                 categories {
                   link
                   name
                   slug
                 }
               }
            }
         }
       `}
       render={data => <CategoriesOutput data={data} {...props} />}
     />
   )
}
